<template>
  <modal
    name="auth"
    :adaptive="true"
    :click-to-close="false"
    height="auto"
    width="90%"
    :max-width="800"
  >
    <div class="flex flex-wrap">
      <div class="auth-meta">
        <PromoLogo full class="logo v-center" />
      </div>
      <div class="w-full md:flex-1 p-4 sm:p-8">
        <Banner
          v-if="alertTitle && alertMessage && !shopifyLoading"
          :title="alertTitle"
          :message="alertMessage"
          type="error"
        />

        <Login
          :auth-type="authType"
          @login-success="onLoginSuccess"
          @shopifyLoading="onShopifyLoading"
        />

        <div v-if="DEVELOPMENT && !shopifyLoading">
          <Button
            v-if="authType === 'shopify'"
            class="auth-toggle-button"
            @click="onToggleAuthType('user')"
          >
            Login with password?
          </Button>
          <Button
            v-if="authType === 'user'"
            class="auth-toggle-button"
            @click="onToggleAuthType('shopify')"
          >
            Login with Shopify?
          </Button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Login from "./Login";
import Banner from "@/components/UI/Banner/Banner";
import PromoLogo from "@/components/UI/PromoLogo";

import EventBus from "@/lib/event-bus.js";

export default {
  name: "AuthModal",
  inject: ["DEVELOPMENT"],
  components: { Banner, Login, PromoLogo },
  data: () => ({
    authType: "shopify",
    alertMessage: "",
    alertTitle: "",
    redirectAfterLogin: true,
    shopifyLoading: false,
  }),
  mounted() {
    this.setupEventBus();
  },
  beforeDestroy() {
    this.removeEventBus();
  },
  methods: {
    onShopifyLoading(loading) {
      this.shopifyLoading = loading;
    },
    onLoginSuccess() {
      // Close the modal if the login was succesful
      this.$modal.hide("auth");

      // If we're redirecting after login...
      if (this.redirectAfterLogin || this.$route.name === "Login") {
        this.$emit("login-success");
        this.$router.push({
          name: "Home",
        });
      }
    },
    onToggleAuthType(type) {
      this.authType = type;
    },
    removeEventBus() {
      EventBus.$off("show-login-modal");
    },
    setupEventBus() {
      EventBus.$on("show-login-modal", (alert) => {
        // Setup the Banner if an alert is passed through
        if (alert) {
          this.alertTitle = this.$get(alert, "title");
          this.alertMessage = this.$get(alert, "message");
        }

        this.$modal.show("auth");
        this.redirectAfterLogin = false;
      });
    },
  },
};
</script>

<style scoped>
>>> .v--modal {
  @apply p-0;
}

.logo {
  @apply block mx-auto;
  max-width: 160px;
  width: 90%;

  @screen sm {
    max-width: 200px;
  }

  @screen md {
    max-width: 280px;
  }
}

.auth-toggle-button {
  @apply p-0 text-grey-dark font-light font-sans no-underline;
  font-size: 12px;

  &:hover {
    @apply underline text-grey-darkest;
  }
}

.auth-meta {
  @apply border-b border-grey-light bg-brand-light w-full py-6 px-4;

  @screen md {
    @apply border-r border-b-0 w-1/2;
    max-width: 233px;
    padding: 0 21px;
  }
}

.loader-wrap {
  min-height: 175.7px;
}

.loader {
  margin: 0;

  >>> div {
    margin-top: 16%;
  }
}

>>> .banner {
  @apply rounded mt-0 mb-5 max-w-xs ml-0;
}

>>> .banner-title-wrap {
  @apply p-2;
}

>>> .banner-message-wrap {
  @apply py-1 px-2;
}

>>> .banner-title {
  @apply text-sm;
}

>>> .banner-message {
  @apply text-xs;
}
</style>
